(function () {
  function fmt(cents) {
    return (cents / 100).toLocaleString('he-IL', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' ₪';
  }

  class FreeShippingBar extends HTMLElement {
    connectedCallback() {
      this.threshold = parseInt(this.getAttribute('data-threshold'), 10) || 0;
      this.msg = this.querySelector('.vfs__msg');
      this.fill = this.querySelector('.vfs__fill');
      this._handler = this.onCartUpdate.bind(this);
      document.addEventListener('cart:updated', this._handler);
    }
    disconnectedCallback() {
      document.removeEventListener('cart:updated', this._handler);
    }
    onCartUpdate(e) {
      var cart = e && e.detail && e.detail.cart;
      if (cart && typeof cart.total_price === 'number') {
        this.render(cart.total_price);
      } else {
        var self = this;
        fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { self.render(c.total_price); }).catch(function () {});
      }
    }
    render(total) {
      if (!this.threshold || !this.msg || !this.fill) return;
      var rem = this.threshold - total;
      var pct = Math.max(0, Math.min(100, Math.round((total * 100) / this.threshold)));
      this.fill.style.width = pct + '%';
      if (rem <= 0) {
        this.classList.add('is-complete');
        this.msg.innerHTML = '<strong>מזל טוב!</strong> המשלוח עלינו';
      } else {
        this.classList.remove('is-complete');
        this.msg.innerHTML = 'עוד <strong>' + fmt(rem) + '</strong> ותיהנו ממשלוח חינם';
      }
    }
  }

  if (!customElements.get('free-shipping-bar')) customElements.define('free-shipping-bar', FreeShippingBar);

  class CartRecommendations extends HTMLElement {
    connectedCallback() {
      this.root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      this._handler = this.onCartUpdate.bind(this);
      document.addEventListener('cart:updated', this._handler);
      this.addEventListener('click', this.onClick.bind(this));
      this.load();
    }
    disconnectedCallback() {
      document.removeEventListener('cart:updated', this._handler);
    }
    onCartUpdate(e) {
      var c = e && e.detail && e.detail.cart;
      if (c && c.item_count === 0) { this.innerHTML = ''; return; }
      this.load();
    }
    load() {
      var self = this;
      fetch(this.root + '?section_id=cart-recommendations', { headers: { Accept: 'text/html' } })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var rec = new DOMParser().parseFromString(html, 'text/html').querySelector('.vrec');
          self.innerHTML = rec ? rec.outerHTML : '';
        }).catch(function () {});
    }
    onClick(e) {
      var size = e.target.closest('.vrec__size');
      if (size) { e.preventDefault(); if (!size.disabled) this.add(size.getAttribute('data-add-id'), size); return; }
      var add = e.target.closest('.vrec__add');
      if (!add) return;
      e.preventDefault();
      if (add.hasAttribute('data-add-id')) { this.add(add.getAttribute('data-add-id'), add); return; }
      // toggle size picker
      var card = add.closest('.vrec__card');
      var sizes = card && card.querySelector('.vrec__sizes');
      this.querySelectorAll('.vrec__sizes').forEach(function (s) { if (s !== sizes) s.hidden = true; });
      if (sizes) sizes.hidden = !sizes.hidden;
    }
    add(id, btn) {
      if (!id) return;
      btn.classList.add('is-loading');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
          return fetch('/cart.js');
        })
        .then(function (r) { return r.json(); })
        .then(function (c) { document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: c } })); })
        .catch(function () { btn.classList.remove('is-loading'); });
    }
  }
  if (!customElements.get('cart-recommendations')) customElements.define('cart-recommendations', CartRecommendations);
})();
